<div class="agpr-agentUsageDashboard">
    <!-- Suppressed inside the expanded dialog, which draws its own -->
    @if (showHeader) {
        <div class="agpr-agentUsageDashboard-header">
            <agpr-button
                id="agentUsageDashboard.expand"
                [style]="buttonTypes.icon"
                icon="fa-solid fa-angle-left"
                tooltip="AutomationAgents.usage.expand"
                tooltipPosition="right"
                [ariaLabel]="'AutomationAgents.usage.expand' | localize"
                (click)="expanded.emit()"
            ></agpr-button>
            <h2 class="agpr-agentUsageDashboard-title">{{ 'AutomationAgents.usage.heading' | localize }}</h2>
        </div>
    }

    <div class="agpr-agentUsageDashboard-card" [agprLoading]="loading">
        <div class="agpr-agentUsageDashboard-cardContent">
            <agpr-dropdown
                id="agentUsageDashboard.period"
                [options]="periodOptions"
                [bindToValue]="true"
                [ngModel]="selectedPeriod"
                (ngModelChange)="periodChanged($event)"
                [ariaLabel]="'AutomationAgents.usage.period' | localize"
            ></agpr-dropdown>

            @if (periodUnavailable) {
                <agpr-message
                    id="agentUsageDashboard.noPeriod"
                    class="agpr-agentUsageDashboard-noPeriod"
                    [severity]="messageSeverity.noContent"
                    [bottomMargin]="false"
                >
                    {{ 'AutomationAgents.usage.noPeriod' | localize }}
                </agpr-message>
            } @else {
            <div class="agpr-agentUsageDashboard-chart">
                <agpr-chart [chart]="dailyAverageUsageChart"></agpr-chart>
            </div>

            <dl class="agpr-agentUsageDashboard-stats">
                <div class="agpr-agentUsageDashboard-stat">
                    <dt>{{ 'AutomationAgents.usage.totalQuota' | localize }}</dt>
                    <dd>{{ totalQuota }}</dd>
                </div>
                <div class="agpr-agentUsageDashboard-stat">
                    <dt>{{ 'AutomationAgents.usage.quotaUsed' | localize }}</dt>
                    <dd>{{ quotaUsed }}</dd>
                </div>
                <div class="agpr-agentUsageDashboard-stat">
                    <dt>{{ 'AutomationAgents.usage.quotaUsedPercent' | localize }}</dt>
                    <dd>{{ quotaUsedPercentage }}</dd>
                </div>
                <div class="agpr-agentUsageDashboard-stat">
                    <dt>{{ 'AutomationAgents.usage.daysRemaining' | localize }}</dt>
                    <dd>{{ daysRemaining }}</dd>
                </div>
                <div class="agpr-agentUsageDashboard-stat">
                    <dt>{{ 'AutomationAgents.usage.resetDate' | localize }}</dt>
                    <dd class="agpr-agentUsageDashboard-stat-date">{{ quotaResetDate }}</dd>
                </div>
            </dl>
            }
        </div>
    </div>
</div>
